export default "__VITE_ASSET__BgQx7qBp__"